module.exports = __webpack_public_path__ + "static/media/Operandum-Platform__Original.7155bd74.png";